<template>
    <div class="box-post fade-up relative flex flex-col">
        <a :href="post.link" class="block bg-dark-400 relative">
            <ImageBG :image="post.image" class="relative left-auto top-auto w-auto h-auto" image-class="w-full !h-[300px] object-cover"></ImageBG>
        </a>

        <div class="bg-white px-5 pt-7 pb-8 flex flex-col h-full">
            <span class="block mb-2.5 text-ch2">{{post.category}}</span>
            <a :href="post.link" class="text-h4 text-darkblue" :aria-label="post.title">{{post.title}}</a>
            <p class="text-3 mt-2.5">{{post.content}}</p>
            <div class="flex-grow w-full"></div>
            <a :href="post.link" :aria-label="post.title" class="group flex justify-center items-center mt-6 font-bold text-6 tracking-[0.32px] leading-none text-darkblue-600 hover:text-darkblue-800 focus:text-darkblue">
                <docs class="[&_path]:fill-darkblue-600 group-hover:[&_path]:fill-darkblue-800 group-focus:[&_path]:fill-darkblue"/>
                <span class="ml-2">Continue reading</span>
            </a>
        </div>
    </div>
</template>

<script>
import ImageBG from "./ImageBG";
import Docs from "../icons/docs.vue";

export default {
  name: "box-post",
    props: {
      post: [Object, Array],
    },
    components: {
        Docs,
      ImageBG,
    },
}
</script>

<style scoped lang="scss">
    .fade-up {
        animation: anim .3s ease both;
    
        @keyframes anim {
            from {
                @apply opacity-0;
            }
            to {
                @apply opacity-100;
            }
        }
    }
</style>